export const getLanguage = state => state.language;
